import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="14" height="16" viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 3.07L5.83 8 12 12.93V3.07zm.31 12.25L3.98 8.65a.83.83 0 010-1.3L12.3.68a.83.83 0 011.36.65v13.34c0 .7-.81 1.09-1.36.65zM2 13.83V2.17a.83.83 0 10-1.67 0v11.66a.83.83 0 001.67 0z" fill="#D8D8D8" fillRule="evenodd" /></svg>);